// extracted by mini-css-extract-plugin
export default {"header":"ClaimTicketLine_header__r6cGq","content":"ClaimTicketLine_content__OR8Z3"};